import { render, staticRenderFns } from "./ProfessionalVideo.vue?vue&type=template&id=74c1b544&scoped=true"
import script from "./ProfessionalVideo.vue?vue&type=script&lang=js"
export * from "./ProfessionalVideo.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalVideo.scss?vue&type=style&index=0&id=74c1b544&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1b544",
  null
  
)

export default component.exports